module.exports = __webpack_public_path__ + "static/img/theme4.04818a38.png";